import { LaneForm } from './LaneForm';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { useSelectedLane } from './selectedLaneState';

const NEW_LANE_ID = 'newLane';

export const NewLaneForm = () => {
  const { t } = useTranslation('locations');
  const { selectedLane, setSelectedLane } = useSelectedLane();

  const onAddLane = () => {
    setSelectedLane({ id: NEW_LANE_ID });
  };

  const onClose = () => {
    setSelectedLane(undefined);
  };

  const isOpen = selectedLane?.id === NEW_LANE_ID;
  return (
    <>
      <Button onClick={onAddLane} color='secondary' variant='outlined'>
        {t('newLane')}
      </Button>
      {isOpen ? <LaneForm isNew onClose={onClose} /> : null}
    </>
  );
};
